if (process.env.NODE_ENV === "production") {
  // disable console in production mode
  /* eslint-disable no-native-reassign */
  console = console || {};
  console.log = console.warn = console.error = console.timeEnd = console.time = function() {};
  /* eslint-enable no-native-reassign */
} else {
  console.log("* dev mode, console is enabled.");
}
